import { render, staticRenderFns } from "./managers.vue?vue&type=template&id=779b636a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779b636a')) {
      api.createRecord('779b636a', component.options)
    } else {
      api.reload('779b636a', component.options)
    }
    module.hot.accept("./managers.vue?vue&type=template&id=779b636a", function () {
      api.rerender('779b636a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/managers.vue"
export default component.exports